import {
  Grid,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { FC, useEffect, useState, useRef, useContext } from "react";
import { useStyles } from "../Styles/LockTokenStyles";
import { LockActionProps } from "../../interfaces";
import ticketLogo from "../../assets/images/ticket_bg_logo.png";
import SmallFire from '../../assets/images/small_fire.svg';
import MediumFire from '../../assets/images/medium_fire.svg';
import BigFire from '../../assets/images/big_fire.svg';
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import AuthContext from "../../store/Auth/AuthContext";
import { nextTierRequirement, tierLevel } from "../../utils/constants/helpers";
import TicketsIcon from "../../assets/images/HeaderTicketsIcon.svg";
import { TokenDollar } from "../../utils/currency/usd";

const NextTierArrow = () => (
  <svg width="78" height="16" viewBox="0 0 78 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M77.7071 8.70711C78.0976 8.31659 78.0976 7.68342 77.7071 7.2929L71.3431 0.928938C70.9526 0.538414 70.3195 0.538414 69.9289 0.928938C69.5384 1.31946 69.5384 1.95263 69.9289 2.34315L75.5858 8.00001L69.9289 13.6569C69.5384 14.0474 69.5384 14.6805 69.9289 15.0711C70.3195 15.4616 70.9526 15.4616 71.3431 15.0711L77.7071 8.70711ZM-8.74228e-08 9L77 9.00001L77 7.00001L8.74228e-08 7L-8.74228e-08 9Z" fill="#3EB8AA"/>
  </svg>
)

const LockActionCard: FC<LockActionProps> = ({
  gainsBalance,
  totalTokens,
  duration,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const updateTimer = useRef({});

  const { lockedGains } = useContext<any>(SubscriptionContext);
  const { getProfileData } = useContext<any>(AuthContext);

  const [, setTicketsOutline] = useState(false);
  const [totalBonus, setTotalBonus] = useState(1);
  const [durationBonus, setDurationBonus] = useState(0);
  const [tierBonus, setTierBonus] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);

  const setUpdate = () => {
    setTicketsOutline(true);
    updateTimer.current = setTimeout(() => {
      setTicketsOutline(false);
      updateTimer.current = 0;
    }, 1000);
  };

  const getDurationBonus = (duration: number) => {
    switch (duration) {
      case 12:
        return 20;
      case 6:
        return 10;
      case 3:
        return 5;
      case 1:
        return 0;
      default:
        return 0;
    }
  }

  const getTierBonus = () => {
    let tierValue = lockedGains + Number(totalTokens)
    if (tierValue < 3000) return 0;
    if (tierValue < 10000) return 5;
    if (tierValue < 25000) return 10;
    if (tierValue < 50000) return 15;
    else return 20;
  }

  useEffect(() => {
    if (totalTokens > 0) {
      let durationBonus = getDurationBonus(duration);
      let tierBonus = getTierBonus();
      setTotalTickets(Math.round(Math.floor(totalTokens/250) * +(1 + (tierBonus/100) + (durationBonus/100)).toFixed(2)))
      setTierBonus(tierBonus);
      setDurationBonus(durationBonus);
      setTotalBonus(+(1 + (durationBonus/100) + (tierBonus/100)).toFixed(2));
      setUpdate();
    } else {
      setTierBonus(0);
      setDurationBonus(0);
      setTotalBonus(1);
      setTotalTickets(0)
    };
  }, [totalTokens, duration]);

  useEffect(() => {
    return () => {
      if (updateTimer.current) {
        clearTimeout(updateTimer.current as any);
      }
    };
  }, []);

  const getFireIcon = () => {
    let tierValue = lockedGains + Number(totalTokens);
    if (tierValue < 10000) return SmallFire;
    else if (tierValue < 30000) return MediumFire;
    else return BigFire;
  }


  return (
    <>
      <Grid
           item
           className={isActive ? classes.lockActionCardSm : classes.lockActionCard}
           lg={5}
           md={6}
           sm={12}
           xs={12}>
        <>
        {!isActive && <>
          <Typography className={classes.tierLabel}>
           Assigned Tier
          </Typography>
          <Typography className={classes.tierValue}>
          {tierLevel(getProfileData?.learnpad_tier)}
          </Typography>
          </>}
         {(!isActive && lockedGains < 50000) && <Grid container>
           <Grid item className={classes.successRate} xs={12} 
             style={{ marginTop: isActive ? "0px" : "2.5rem" }}>
             <Box display={"flex"} flexDirection="column">
               <Typography
                  component="p"
                >
                  $GAINS
                </Typography>
                <Typography
                  component="h3"
                >
                  {TokenDollar(lockedGains)}
                </Typography>
                </Box>
                <NextTierArrow/>
               <Box display={"flex"} flexDirection="column">
               <Typography
                  component="p"
                >
                  Next Tier
                </Typography>
                <Typography
                  component="h3"
                >
                  {TokenDollar(nextTierRequirement(getProfileData?.learnpad_tier))}
                </Typography>
                </Box>
           </Grid>
          </Grid>}
          <Typography
           className={classes.tierValue}
           style={{
            fontSize:"1rem", 
            marginTop:isActive ? '0' : "2.25rem", 
            marginBottom:"1rem"
          
          }}
          >
            Rewards
          </Typography>

          <Grid 
            container 
            justifyContent={isActive ? 'space-around' : "space-between"} 
            style={{paddingBottom:isActive ? "3rem" : 0}}>
          <Grid 
          item 
          style={{flexDirection:"column", alignItems:"flex-start"}}  
          className={classes.successRate} 
          xs={5} 
          md={12}
          
          >
              <Typography
                component="p"
              >
                Lottery Tickets
              </Typography>
              <Typography
                component="h3"
                style={{marginTop:isActive ? '1rem' : "1.875rem"}}
              >
                <img src={TicketsIcon} alt="tickets" style={{marginRight:".5rem"}} />        
                  {totalTickets}
              </Typography>
            
          </Grid>
            <Grid 
            item 
            style={{
              flexDirection: "column",
              alignItems:"flex-start"
            }} 
            className={classes.ticketsBox}  xs={5} md={12}>
              <>
               
                  <Typography
                    component="p"
                  >
                    Total Bonus
                  </Typography>
                  <img src={ticketLogo} alt="tickets" className="ticket-logo" />
                <Typography
                   style={{marginTop:isActive ? '1rem' : "1.875rem"}}
                  component="h3"
                >
                  {
                    durationBonus === 0 && tierBonus === 0
                      ? "No Bonus 🙁"
                      : `x${totalBonus}`
                  }
                  &nbsp;
                  <span style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    {
                      durationBonus === 0 && tierBonus === 0
                        ? ""
                        : `(${durationBonus}% + ${tierBonus}%)`
                    }
                  </span>
                </Typography>{" "}
              </>
            </Grid>
            {!isActive &&  <Grid item justifyContent="center" style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2.5rem",
              alignItems: "center",
              width: "100%",
            }}>
              <Typography className={classes.learnMore}>
                <a 
                 style={{color:'#3EB8AA', textDecoration:'none'}} 
                 target={"_blank"} 
                 href="http://gainsassociates.medium.com/how-the-gainspad-tier-system-works-95195dc84d22" 
                 rel="noreferrer">
                  Learn more
                </a>
                {" "}about rewards
              </Typography>

            </Grid>
}
          </Grid>
        </>
      </Grid>
    </>
  );
};

export default LockActionCard;
